import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { POST, GET } from "../../helpers/apiHelper";
import * as action from "./actions";
import { unauthorizeUser, setSyncJobProgress } from "../../helpers/utility";

const startSyncAsync = async (item) => POST(`/entra-sync/trigger`, item, { idempotent: true });
const loadProgressSyncAsync = async (id) => GET(`/entra-sync/status/${id}`);
const cancelSyncAsync = async (jobId) => GET(`/entra-sync/cancel/${jobId}`);

/**
 * Saga to add or edit a municipal.
 * Handles both create and update with sync job initialization.
 * @param {Object} action - Redux action.
 * @param {Object} action.payload - Payload containing municipal data.
 * @param {Object} action.payload.item - data object.
 * @param {Object} action.payload.history - React Router history for navigation.
 */
function* startSync({ payload }) {
  try {
    if (payload.item) {
      console.log('startSyncAsync payload.item', payload.item);
      const response = yield call(startSyncAsync, { municipalId: payload?.item?.sourced_id, syncType: payload?.syncType });
      console.log('startSyncAsync job', response);
      
      // Store sync job info to localStorage
      if (response?.data?.jobId) {
        setSyncJobProgress(response.data.jobId, "entra_id", "import");
      }
      
      const { history } = payload;
      history.push(`/entra-sync/${response?.data?.jobId}`);
    } else {
      yield put(action.startSyncError("invalid item, cannot be null"));
    }
  } catch (error) {
    console.log('startSyncAsync error', error);
    yield put(action.startSyncError(error?.response?.data?.errors?.[0]?.detail));
  }
}

/**
 * Saga to track municipal sync process progress.
 * @param {Object} action - Redux action.
 * @param {Object} action.payload - Payload containing sync information.
 * @param {string} action.payload.id - Sync job ID.
 */
function* loadProcessSync({ payload }) {
  try {
    const response = yield call(loadProgressSyncAsync, payload.id);
    yield put(action.progressSyncSuccess(response));
  } catch (error) {
    console.log('loadProgressSyncAsync error', error)
    console.log('loadProgressSyncAsync error.response', error?.response)
    console.log('loadProgressSyncAsync error.response.status', error?.response?.status)

    // Handle CORS or 502 errors
    if (error instanceof TypeError || (error?.response && error?.response?.status === 502)) {
      yield put(action.progressSyncError({ progress: 0 }));
      return;
    }else if (error.message === "Network Error") {
      console.warn("Potential CORS issue or server unreachable (502).");
      yield put(action.progressSyncError({ progress: 0 }));
      return;
    }
    
    yield call(unauthorizeUser(error));
    yield put(action.progressSyncError(error));
  }
}

export function* watchStartSync() {;
  yield takeEvery(action.START_SYNC, startSync)
}

export function* watchProgressSync() {;
  yield takeEvery(action.PROGRESS_SYNC, loadProcessSync);
}
  
function* performCancelSync({ payload }) {
  try {
    const { jobId, history } = payload;
    const response = yield call(cancelSyncAsync, jobId);
    yield put(action.cancelSyncSuccess(response));
    if (history) {
      history.push('/import-log');
    }
  } catch (error) {
    yield call(unauthorizeUser, error);
    yield put(action.cancelSyncError(error));
  }
}

export function* watchCancelSync() {
  yield takeEvery(action.CANCEL_SYNC, performCancelSync);
}
  
/**
 * Root saga for all filter-related actions.
 *
 * @generator
 */
export default function* rootSaga() {
  yield all([
    fork(watchStartSync),
    fork(watchProgressSync),
    fork(watchCancelSync),
  ]);
}